import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Container from '@mui/material/Container'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined'
import SendToMobileOutlinedIcon from '@mui/icons-material/SendToMobileOutlined'
import InstagramIcon from '@mui/icons-material/Instagram'
import { useTranslation } from 'react-i18next'
import { analytics } from '../../../analytics'

// Utility function to handle URL sharing
const handleShare = async (t) => {
  const currentUrl = 'https://www.peakssports.com/races/goat-ultra-trail-race/details'
  const shareData = {
    title: document.title,
    url: currentUrl
  }

  // Check if Web Share API is available (mobile)
  if (navigator.share) {
    try {
      await navigator.share(shareData)
      // Track successful share
      analytics.track('share_completed', {
        content_type: 'link',
        share_method: 'web_share_api',
        share_url: currentUrl,
        page_title: document.title
      })
    } catch (error) {
      // User cancelled or sharing failed, silently ignore
      analytics.track('share_cancelled', {
        content_type: 'link',
        share_method: 'web_share_api',
        share_url: currentUrl,
        error_message: error.message
      })
    }
  } else {
    // Fallback for desktop: copy to clipboard
    try {
      await navigator.clipboard.writeText(currentUrl)
      // Show notification
      alert(t('links.copied'))
      // Track successful clipboard copy
      analytics.track('share_completed', {
        content_type: 'link',
        share_method: 'clipboard',
        share_url: currentUrl,
        page_title: document.title
      })
    } catch (error) {
      // Fallback if clipboard API fails
      alert(t('links.copyFailed'))
      // Track clipboard failure
      analytics.track('share_failed', {
        content_type: 'link',
        share_method: 'clipboard',
        share_url: currentUrl,
        error_message: error.message
      })
    }
  }
}

// Track button clicks
const trackButtonClick = (buttonName, url = null) => {
  analytics.track('button_click', {
    button_name: buttonName,
    page_title: document.title,
    page_url: window.location.href,
    ...(url && { destination_url: url })
  })
}

export default function Links ({ eventDetails }) {
  const { t } = useTranslation('race')
  return (
    <Container maxWidth='xl' sx={{ textAlign: 'center' }}>
      {eventDetails?.slug === 'goat-ultra-trail-race'
        ? <Box sx={{ mt: 3 }}>
          <Button
            component={Link}
            variant='outlined'
            color='primary'
            startIcon={<HowToRegOutlinedIcon />}
            sx={{
              width: 320,
              mb: 5,
              color: 'white',
              '&:hover': { color: '#ddd' },
              borderWidth: 2,
              py: 2,
              px: 6
            }}
            target='_blank'
            href='https://my.raceresult.com/366560/registration?regname=Registration'
            onClick={() => trackButtonClick('registration', 'https://my.raceresult.com/366560/registration?regname=Registration')}
          >
            {t('links.registration')}
          </Button> <br/>
          <Button
            component={Link}
            variant='outlined'
            color='primary'
            startIcon={<WhatsAppIcon />}
            sx={{
              width: 320,
              mb: 5,
              color: 'white',
              '&:hover': { color: '#ddd' },
              borderWidth: 2,
              py: 2,
              px: 6
            }}
            target='_blank'
            href='https://chat.whatsapp.com/HQ4mM6YgqKZ2bR4B9iaJmz'
            onClick={() => trackButtonClick('whatsapp_group', 'https://chat.whatsapp.com/HQ4mM6YgqKZ2bR4B9iaJmz')}
          >
            {t('links.joinWhatsApp')}
          </Button><br />
          <Button
            component={Link}
            variant='outlined'
            color='primary'
            startIcon={<InstagramIcon />}
            sx={{
              width: 320,
              mb: 5,
              color: 'white',
              '&:hover': { color: '#ddd' },
              borderWidth: 2,
              py: 2,
              px: 6
            }}
            target='_blank'
            href='https://www.instagram.com/peaks_sports/'
            onClick={() => trackButtonClick('instagram_follow', 'https://www.instagram.com/peaks_sports/')}
          >
            {t('links.followInstagram')}
          </Button><br />
          <Button
            variant='outlined'
            color='primary'
            startIcon={<SendToMobileOutlinedIcon />}
            sx={{
              width: 320,
              mb: 5,
              color: 'white',
              '&:hover': { color: '#ddd' },
              borderWidth: 2,
              py: 2,
              px: 6
            }}
            onClick={() => {
              trackButtonClick('share_with_others')
              handleShare(t)
            }}
          >
            {t('links.share')}
          </Button>
        </Box>
        : <Typography variant='h6'>{t('links.inactive')}</Typography>
      }

    </Container>
  )
}
